import { render, staticRenderFns } from "./AllStats.vue?vue&type=template&id=74e272c6&scoped=true&"
import script from "./AllStats.vue?vue&type=script&lang=js&"
export * from "./AllStats.vue?vue&type=script&lang=js&"
import style0 from "./AllStats.vue?vue&type=style&index=0&id=74e272c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e272c6",
  null
  
)

export default component.exports